import { DIET_STATUS } from '../../../constants/diet';

/** Non-chief assign on edit keeps live plan status; new/copy/draft-submit still go pending. */
export const assignStatusForSave = (
  asDraft: boolean,
  opts: { isChief: boolean; editingPlanId: unknown; loadedStatus: string | null },
): string => {
  if (asDraft) return DIET_STATUS.DRAFT;
  if (opts.isChief) return 'Published';
  if (opts.editingPlanId && opts.loadedStatus) {
    const st = opts.loadedStatus.toLowerCase();
    if (st === DIET_STATUS.APPROVED || st === DIET_STATUS.PUBLISHED) {
      return DIET_STATUS.APPROVED;
    }
    if (st === DIET_STATUS.PENDING) return DIET_STATUS.PENDING;
  }
  return DIET_STATUS.PENDING;
};
